import React from "react";
import SectionBlock from "../../../../global/components/FeatureCard/SectionBlock";
import threatLevelManagement from "../../../../assets/images/threatLevelManage/threat-level-management.png";
import threatAssignment from "../../../../assets/images/threatLevelManage/threat-assignment.png";

const PAGE_X = "px-6 lg:px-[120px]";

const sections = [
  {
    image: threatLevelManagement,
    label: "Configurable Threat Level Management",
    description:
      "The Threat Level feature provides a five-tier security escalation framework—Low, Guarded, Elevated, High, and Severe—enabling administrators to dynamically adjust access restrictions across the facility in response to evolving security conditions. Each threat level can be customized with organization-specific names, aligning with existing security protocols and incident response procedures. When a threat level is activated, the system automatically evaluates and enforces access restrictions based on predefined door and cardholder threat assignments, overriding existing unlock schedules where necessary. This centralized approach eliminates manual door-by-door configuration during security incidents, ensuring rapid and consistent enforcement of elevated security measures across all connected devices.",
    imageLeft: true,
    imageBg: "#ffffff",
    textBg: "#f8f8f8",
    bodyColor: "#5b5b5b",
    imageMaxWidth: "590px",
    sectionHeight: "540px",
  },
  {
    image: threatAssignment,
    label: "Threat Assignment Across Doors and Personnel",
    description:
      "The threat assignment framework operates across three distinct layers — System, Door, and Cardholder — creating a rock-solid access control mechanism that governs entry permissions based on relative threat levels. Each door is assigned a specific threat threshold, and when the system threat level exceeds that door's configured level, the door automatically locks regardless of existing unlock schedules. Similarly, each cardholder is assigned an individual threat level, and access is denied if either the system or door threat level exceeds the cardholder's assigned threshold. The Dashboard delivers manual override capabilities (M-Unlock and E-Unlock) for authorized administrators to manage exceptions, maintaining operational continuity while preserving the integrity of the threat-based security posture.",
    imageLeft: false,
    imageBg: "#ffffff",
    textBg: "#f8f8f8",
    bodyColor: "#5b5b5b",
    imageMaxWidth: "590px",
    sectionHeight: "640px",
    textAlign: "right",
  },
];

export const ThreatLevelManageContent = () => (
  <div className="bg-white w-full">
    <section
      className={`bg-white flex flex-col items-center justify-center gap-6 ${PAGE_X} pt-28 sm:pt-24 min-h-[258px] text-center`}
    >
      <h1 className="text-black text-[32px] font-medium font-['Inter'] leading-normal max-w-[1004px]">
        Threat Level & Security Response
      </h1>
      <p className="text-[#5b5b5b] text-[20px] font-medium font-['Poppins'] leading-normal max-w-[792px]">
        Adapt to evolving security conditions with dynamic threat escalation,
        automated enforcement, and intelligent event-driven response control.
      </p>
    </section>

    <div className="w-full bg-white mt-6">
      {sections.map((section) => (
        <SectionBlock key={section.label} {...section} />
      ))}
    </div>
  </div>
);
